var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "logreg-header clearfix" }, [
    _c("div", { staticClass: "header-left" }, [
      _c("div", { staticClass: "logo", attrs: { title: "商维宝" } }, [
        _c("img", {
          directives: [
            {
              name: "resc-url",
              rawName: "v-resc-url",
              value: "/app/image/logo/plat-logo.png",
              expression: "'/app/image/logo/plat-logo.png'"
            }
          ]
        })
      ]),
      _vm._v(" "),
      _c("a", { staticClass: "font-gold ml15 mt30 font24 fl" }, [
        _vm._v(_vm._s(_vm.item.name))
      ])
    ]),
    _vm._v(" "),
    _vm.item.type == "regist" || _vm.item.type == "reset"
      ? _c("div", { staticClass: "header-right" }, [
          _c(
            "b",
            {
              staticClass: "ml15 fl font-gray2 font16",
              staticStyle: { "margin-top": "40px" }
            },
            [
              _vm._v("已有账号？\n        "),
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "app-url",
                      rawName: "v-app-url",
                      value: "/user/login/jsp",
                      expression: "'/user/login/jsp'"
                    }
                  ],
                  staticClass: "font-gray4"
                },
                [_vm._v("请登录")]
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4445afe3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4445afe3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/user/Login-head.vue
// module id = 3474
// module chunks = 1